const BASEURL = 'https://api.epicgame.me'


export const endPoint = {

  USER_REGISTER: `${BASEURL}/api/Auth/register`,
  USER_LOGIN: `${BASEURL}/api/Auth/login`,
  USER_LIST: `${BASEURL}/api/Auth/get-admin-users`,
  GAME_LIST: `${BASEURL}/api/Auth/get-games`,
  CREATE_ADMIN_USER: `${BASEURL}/api/Auth/add-admin`,
  CREATE_GAME_USER: `${BASEURL}/api/Auth/add-game-user`,
  GET_GAME_USER: `${BASEURL}/api/Auth/game-users`,
  UPDATE_GAME_USER: `${BASEURL}/api/Auth/update-game-user`,
  CREATE_WALLET: `${BASEURL}/api/Auth/create-user-wallet`,
  UPDATE_WALLET_DETAILS: `${BASEURL}/api/Auth/update-user-wallet`,
  GET_WALLET_DETAILS: `${BASEURL}/api/Auth/get-user-wallet`,
  GET_USER_LEVEL: `${BASEURL}/api/Auth/levels`,
  CREATE_ORDER: `${BASEURL}/api/Auth/create-order`,
  UPDATE_ORDER: `${BASEURL}/api/Auth/update-order`,
  GET_ORDER: `${BASEURL}/api/Auth/get-orders`,
  POST_DEPOSIT: `${BASEURL}/api/Auth/AddDebit`,
  GET_USER_GAME: `${BASEURL}/api/Auth/get-games-for-user`,
  SET_NEGATIVE: `${BASEURL}/api/Auth/set-user-negative-levels`,
  PLAY_GAME: `${BASEURL}/api/Auth/play-game`,
  RESET_PASSWORD: `${BASEURL}/api/Auth/reset-password`,
  GET_HISTORY: `${BASEURL}/api/Auth/user-game-history/`,
  GET_NAGITIVE: `${BASEURL}/api/Auth/get-user-negative`,
  UPDATE_NAGITIVE: `${BASEURL}/api/Auth/update-negative-levels`,
  DELETE_NEGITIVE: `${BASEURL}/api/Auth/delete-negative-levels`,
  RESET_USER: `${BASEURL}/api/Auth/reset-user`,
  PLAY_PERMISSION: `${BASEURL}/api/Auth/check-game-play-permission`,
  CHECK_BALANCE: `${BASEURL}/api/Auth/search-user-balance-with-game`,
  
}
